import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ExportQueueService from '../../../Services/ExportQueueService';
import EOMExportItem from './EOMExportItem';
import EomExportFilterTypeEnum from '../../../Enums/EomExportFilterTypeEnum';

export default class EomExportWindowDescription {
  static titleForCreate = 'EOM Export';
  static titleForEdit = 'EOM Export';
  static finishButtonLabel = 'Start EOM Export';
  static itemType = EOMExportItem;
  static serviceFunction = (edited) => ExportQueueService.StartEndOfMonthExport(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The payment exports queues will be created in the background, you will receive a notification.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'FilterType',
          label: 'Restrict Export To',
          className: 'col-12',
          type: InputTypesEnum.Select,
          selectvalues: EomExportWindowDescription.getFilterTypeOptions,
          validityChecker: ValidityHelper.forRequiredSelectField,
        },
        {
          fieldName: 'EvaluatorIds',
          label: 'Bravo Evaluator IDs (id1, id2, ...)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: EomExportWindowDescription.ValidateIdList,
          hide: (item) => item.FilterType !== EomExportFilterTypeEnum.Evaluator,
        },
        {
          fieldName: 'TpEvaluatorIds',
          label: 'Bravo TP Evaluator IDs (id1, id2, ...)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: EomExportWindowDescription.ValidateIdList,
          hide: (item) => item.FilterType !== EomExportFilterTypeEnum.TpEvaluator,
        },
        {
          fieldName: 'ClientInvoiceIds',
          label: 'Bravo Client Invoice IDs (id1, id2, ...)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: EomExportWindowDescription.ValidateIdList,
          hide: (item) => item.FilterType !== EomExportFilterTypeEnum.ClientInvoice,
        },
        {
          fieldName: 'TpClientInvoiceIds',
          label: 'Bravo TP Client Invoice IDs (id1, id2, ...)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: EomExportWindowDescription.ValidateIdList,
          hide: (item) => item.FilterType !== EomExportFilterTypeEnum.TpClientInvoice,
        },
        {
          fieldName: 'ClientIds',
          label: 'Bravo Client IDs (id1, id2, ...)',
          className: 'col-12',
          type: InputTypesEnum.Text,
          validityChecker: EomExportWindowDescription.ValidateIdList,
          hide: (item) => item.FilterType !== EomExportFilterTypeEnum.Client,
        },
        {
          fieldName: 'Offices',
          label: 'Evaluator Payment Offices To Export (if possible)',
          className: 'col-12',
          type: InputTypesEnum.OfficeMultiSelect,
          validityChecker: EomExportWindowDescription.ValidateOfficeList,
          hide: (item) =>
            item.FilterType === EomExportFilterTypeEnum.Evaluator ||
            item.FilterType === EomExportFilterTypeEnum.TpEvaluator,
        },
        { fieldName: 'Notes', label: 'Notes', className: 'col-12', type: InputTypesEnum.Notes },
      ],
    },
  ];

  static getFilterTypeOptions() {
    return [
      { label: 'No Restriction (Regular EOM Export)', value: EomExportFilterTypeEnum.All },
      { label: 'Clients', value: EomExportFilterTypeEnum.Client },
      { label: 'Client Invoices', value: EomExportFilterTypeEnum.ClientInvoice },
      { label: 'Third-Party Client Invoices', value: EomExportFilterTypeEnum.TpClientInvoice },
      { label: 'Evaluators', value: EomExportFilterTypeEnum.Evaluator },
      { label: 'Third-Party Evaluators', value: EomExportFilterTypeEnum.TpEvaluator },
    ];
  }

  static ValidateIdList(value, item) {
    switch (item.FilterType) {
      case EomExportFilterTypeEnum.Evaluator:
        return ValidityHelper.forRequiredTextField(item.EvaluatorIds);
      case EomExportFilterTypeEnum.TpEvaluator:
        return ValidityHelper.forRequiredTextField(item.TpEvaluatorIds);
      case EomExportFilterTypeEnum.ClientInvoice:
        return ValidityHelper.forRequiredTextField(item.ClientInvoiceIds);
      case EomExportFilterTypeEnum.TpClientInvoice:
        return ValidityHelper.forRequiredTextField(item.TpClientInvoiceIds);
      case EomExportFilterTypeEnum.Client:
        return ValidityHelper.forRequiredTextField(item.ClientIds);
      default:
        return ValidityHelper.AlwaysFlawless(value);
    }
  }

  static ValidateOfficeList(value, item) {
    if (
      item.FilterType !== EomExportFilterTypeEnum.Evaluator &&
      item.FilterType !== EomExportFilterTypeEnum.TpEvaluator
    ) {
      return ValidityHelper.forRequiredTextField(value);
    }
    return ValidityHelper.AlwaysFlawless(value);
  }
}
